(() => {
  const states = new Set();
  const rtl =
    getComputedStyle(document.documentElement).direction === "rtl";

  let frameId = 0;
  let resizeTimer = 0;
  let lastViewportWidth = window.innerWidth;

  const clamp = (value, min, max) =>
    Math.min(Math.max(value, min), max);

  const updateGeometry = (state) => {
    if (!state.section.isConnected) return;

    if (state.productCard && state.wrapper) {
      const cardHeight = Math.ceil(
        state.productCard.offsetHeight
      );

      const slideHeight =
        parseFloat(
          getComputedStyle(state.child, "::before").height
        ) || 0;

      state.wrapper.style.maxHeight = `${cardHeight}px`;

      const requiredHeight = Math.max(
        cardHeight + 96,
        slideHeight
      );

      state.child.style.minHeight = `${requiredHeight}px`;
    }

    const scrollY =
      window.scrollY || window.pageYOffset;

    const rect =
      state.parent.getBoundingClientRect();

    state.start = rect.top + scrollY;

    state.distance = Math.max(
      1,
      rect.height - state.child.offsetHeight
    );
  };

  const getProgress = (state) => {
    const scrollY =
      window.scrollY || window.pageYOffset;

    return clamp(
      (scrollY - state.start) / state.distance,
      0,
      1
    );
  };

  const applyTransform = (state, progress) => {
    const width = window.innerWidth;
    const smallScreen = width < 990;
    const mediumScreen = width < 1360;

    let translateY = -110 + 110 * progress;
    let translateX = -50;

    if (
      state.productsCount === 4 &&
      !smallScreen
    ) {
      translateY = -50;

      translateX = !mediumScreen
        ? 70 - 70 * progress
        : 76 - 76 * progress;
    } else if (
      state.productsCount !== 4 &&
      !smallScreen &&
      !state.singleProduct
    ) {
      translateY = -50;

      translateX = !mediumScreen
        ? 60 - 60 * progress
        : 67 - 67 * progress;
    } else if (
      !smallScreen &&
      state.singleProduct
    ) {
      translateX = 0;
      translateY = -50 * progress;
    }

    const finalX =
      rtl ? -translateX : translateX;

    const transform =
      `translate3d(${finalX.toFixed(3)}%,` +
      `${translateY.toFixed(3)}%,0)`;

    if (state.lastTransform !== transform) {
      state.inner.style.transform = transform;
      state.lastTransform = transform;
    }
  };

  const render = () => {
    frameId = 0;

    let continueAnimation = false;

    states.forEach((state) => {
      if (!state.section.isConnected) {
        states.delete(state);
        return;
      }

      state.targetProgress =
        getProgress(state);

      const difference =
        state.targetProgress -
        state.currentProgress;

      if (Math.abs(difference) > 0.0005) {
        state.currentProgress +=
          difference * 0.16;

        continueAnimation = true;
      } else {
        state.currentProgress =
          state.targetProgress;
      }

      applyTransform(
        state,
        state.currentProgress
      );
    });

    if (continueAnimation) {
      frameId =
        requestAnimationFrame(render);
    }
  };

  const scheduleRender = () => {
    if (!frameId) {
      frameId =
        requestAnimationFrame(render);
    }
  };

  const recalculate = () => {
    states.forEach((state) => {
      updateGeometry(state);

      state.targetProgress =
        getProgress(state);
    });

    scheduleRender();
  };

  const init = () => {
    document
      .querySelectorAll(
        ".section-scroll-products"
      )
      .forEach((section) => {
        if (
          section.dataset
            .scrollProductsInitialized ===
          "true"
        ) {
          return;
        }

        const parent =
          section.querySelector(
            ".scroll-products__container"
          );

        const child =
          section.querySelector(
            ".scroll-products"
          );

        const inner =
          section.querySelector(
            ".scroll-products__products"
          );

        if (
          !parent ||
          !child ||
          !inner
        ) {
          return;
        }

        const productsCount =
          parseInt(
            child.dataset.productsCount,
            10
          ) || 0;

        const state = {
          section,
          parent,
          child,
          inner,

          wrapper:
            section.querySelector(
              ".scroll-products__wrapper"
            ),

          productCard:
            section.querySelector(
              ".scroll-products__item"
            ),

          productsCount,

          singleProduct:
            productsCount === 1,

          start: 0,
          distance: 1,
          currentProgress: 0,
          targetProgress: 0,
          lastTransform: ""
        };

        section.dataset
          .scrollProductsInitialized =
          "true";

        section.classList.add(
          "scroll_initialized"
        );

        inner.style.willChange =
          "transform";

        inner.style.backfaceVisibility =
          "hidden";

        inner.style
          .webkitBackfaceVisibility =
          "hidden";

        states.add(state);

        updateGeometry(state);

        state.currentProgress =
          getProgress(state);

        state.targetProgress =
          state.currentProgress;

        applyTransform(
          state,
          state.currentProgress
        );

        section
          .querySelectorAll("img")
          .forEach((image) => {
            if (!image.complete) {
              image.addEventListener(
                "load",
                recalculate,
                {
                  once: true
                }
              );
            }
          });
      });
  };

  window.addEventListener(
    "scroll",
    scheduleRender,
    {
      passive: true
    }
  );

  window.addEventListener(
    "resize",
    () => {
      const newViewportWidth =
        window.innerWidth;

      /*
        Safari changes viewport height
        while scrolling when the browser
        bars appear or disappear.

        Ignore resize events where only
        the height changed.
      */
      if (
        Math.abs(
          newViewportWidth -
          lastViewportWidth
        ) < 2
      ) {
        return;
      }

      lastViewportWidth =
        newViewportWidth;

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        recalculate();
      }, 150);
    },
    {
      passive: true
    }
  );

  window.addEventListener(
    "orientationchange",
    () => {
      setTimeout(() => {
        lastViewportWidth =
          window.innerWidth;

        recalculate();
      }, 250);
    }
  );

  window.addEventListener(
    "load",
    recalculate,
    {
      once: true
    }
  );

  if (document.fonts?.ready) {
    document.fonts.ready.then(
      recalculate
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }

  document.addEventListener(
    "shopify:section:load",
    () => {
      init();
      recalculate();
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    () => {
      states.forEach((state) => {
        if (
          !state.section.isConnected
        ) {
          states.delete(state);
        }
      });
    }
  );
})();